import React from 'react';
import DatasetCollectionAssignRow from './DatasetCollectionAssignRow';

const DatasetCollectionsAssignTableRows = ({
  category,
  code,
  items,
  entity,
  onChange,
  removeCollection,
}) => (
  items.map((item) => (
    <DatasetCollectionAssignRow
      key={`dataset_collection_table_row_${item.code}`}
      collection={item}
      entity={entity}
      onChange={onChange}
      removeCollection={(collectionCode) => removeCollection(category, code, collectionCode)}
    />
  ))
);
export default DatasetCollectionsAssignTableRows;
